
export default function asset_toggle(){

    const assetToggles = document.querySelectorAll('.asset-toggle:not(.bound-click)');


    for (let a = 0; a < assetToggles.length; a++) {

        const assetToggle = assetToggles[a];


        if(!assetToggle.classList.contains('bound-click')){
            
                assetToggle.classList.add('bound-click');
                let assets = Array.from(assetToggle.querySelectorAll('.asset, .project-asset, .video-wrap'));

                assetToggle.addEventListener('click', function(e){

                    const top = assetToggle.querySelectorAll('.top');
                    for (let a = 0; a < top.length; a++) {
                        const element = top[a];
                        element.classList.remove('top');
                    }
            
                    e.preventDefault();
                    assets.push(assets.shift());

                    
                    
                    for (let b = 0; b < assets.length; b++) {
                        const element = assets[b];
                        if(b == 0){
                            element.classList.add('top');
                        }
                        
                        element.style.zIndex = assets.length - b;
                        
                    }

        
    
                });

            }
            
    }

};
